<script setup lang="ts">
import { useToast } from '../composables/useToast';

const { toasts, dismiss } = useToast();
</script>

<template>
  <div class="fx-toasts">
    <div
      v-for="t in toasts"
      :key="t.id"
      class="fx-toast"
      :class="{ 'fx-toast--error': t.kind === 'error' }"
      :role="t.kind === 'error' ? 'alert' : 'status'"
    >
      <span>{{ t.message }}</span>
      <button class="fx-toast__action" :aria-label="`Dismiss: ${t.message}`" @click="dismiss(t.id)">✕</button>
    </div>
  </div>
</template>

<style scoped>
.fx-toast__action { text-decoration: none; }
</style>
